import React from 'react';
import { FocusArea } from 'libs/end-to-end/src/focus-area';
import { AdminPage } from 'apps/sigma2-ui/src/pages/AdminPage';
import { AdminFeatureFlagsPage } from 'apps/sigma2-ui/src/pages/AdminFeatureFlagsPage';
import { AdminSSORoleMappingsPage } from 'apps/sigma2-ui/src/pages/AdminSSORoleMappingsPage';
import { EmailsPage } from 'apps/sigma2-ui/src/pages/EmailsPage';
import { FocusAreaPage } from 'apps/sigma2-ui/src/pages/FocusAreaPageComponent';
import { ForgotPasswordPage } from 'apps/sigma2-ui/src/pages/ForgotPasswordPage';
import { GlossaryPage } from 'apps/sigma2-ui/src/pages/GlossaryPage';
import { Http404Page } from 'apps/sigma2-ui/src/pages/Http404Page';
import { LoginPage } from 'apps/sigma2-ui/src/pages/LoginPage';
import { OrganizationsPage } from 'apps/sigma2-ui/src/pages/OrganizationsPage';
import { OrganizationPrivateNetworkingEntitlementsPage } from 'apps/sigma2-ui/src/pages/OrganizationPrivateNetworkingEntitlementsPage';
import { ExternalStreamlitAppsPage } from 'apps/sigma2-ui/src/pages/ExternalStreamlitAppsPage';
import { ExternalDagsterTransformsPage } from 'apps/sigma2-ui/src/pages/ExternalDagsterTransformsPage';
import { OverviewPage } from 'apps/sigma2-ui/src/pages/OverviewPage';
import { ExplorePage } from 'apps/sigma2-ui/src/explore-section/pages/ExplorePage';
import { ResetPasswordPage } from 'apps/sigma2-ui/src/pages/ResetPasswordPage';
import { CallbackLoginPage } from 'apps/sigma2-ui/src/pages/CallbackLoginPage';
import { CallbackLogoutPage } from 'apps/sigma2-ui/src/pages/CallbackLogoutPage';
import { TreatmentCenterPage } from 'apps/sigma2-ui/src/pages/TreatmentCenterPage';
import { UserPage } from 'apps/sigma2-ui/src/pages/UserPage';
import { UsersPage } from 'apps/sigma2-ui/src/pages/UsersPage';
import { WelcomePage } from 'apps/sigma2-ui/src/pages/WelcomePage';
import { AdminSSOPage } from 'apps/sigma2-ui/src/pages/AdminSSOPage';
import { AdminSSOIdentityProviderPage } from 'apps/sigma2-ui/src/pages/AdminSSOIdentityProviderPage';
import { AdminSSORoleMappingPage } from 'apps/sigma2-ui/src/pages/AdminSSOClaimMappingPage';
import { HomeRedirect } from 'apps/sigma2-ui/src/pages/HomeRedirect';
import { CopilotPage } from 'apps/sigma2-ui/src/copilot/pages/CopilotPage';
import { DatabasesPage } from 'apps/sigma2-ui/src/data-wizard/components/DatabasesPage';
import { DatabasesByOrganizationPage } from 'apps/sigma2-ui/src/data-wizard/components/DatabasesByOrganizationPage';
import { DatabaseSchemaPage } from 'apps/sigma2-ui/src/data-wizard/components/DatabaseSchemaPage';
import { DatabasesNewPage } from 'apps/sigma2-ui/src/data-wizard/components/DatabasesNewPage';
import { DatabasesEditPage } from 'apps/sigma2-ui/src/data-wizard/components/DatabasesEditPage';
import { TransformPage } from 'apps/sigma2-ui/src/data-wizard/components/transform-page/TransformPage';
import { OrganizationEditPage } from 'apps/sigma2-ui/src/organizations/components/OrganizationEditPage';
import { OrganizationNewPage } from 'apps/sigma2-ui/src/organizations/components/OrganizationNewPage';
import { OrganizationEntitlementsPage } from 'apps/sigma2-ui/src/pages/OrganizationEntitlementsPage';
import { DatabasesDataSetsPage } from 'apps/sigma2-ui/src/data-wizard/components/DatabasesDataSetsPage';
import { DataSetNewPage } from 'apps/sigma2-ui/src/data-wizard/components/DataSetNewPage';
import { DataSetEditPage } from 'apps/sigma2-ui/src/data-wizard/components/DataSetEditPage';
import { DataSetPullUploadPage } from 'apps/sigma2-ui/src/data-wizard/components/DataSetPullUploadPage';
import { DatabaseRevisionsPage } from 'apps/sigma2-ui/src/data-wizard/components/DatabaseRevisionsPage';
import { PageRoute } from 'apps/sigma2-ui/src/constants/page-route';
import { DatabaseSchedulePage } from 'apps/sigma2-ui/src/data-wizard/components/DatabaseSchedulePage';
import { DataSetPostProcessingScriptPage } from 'apps/sigma2-ui/src/data-wizard/components/DataSetPostProcessingScriptPage';
import { ProgressPage } from 'apps/sigma2-ui/src/pages/ProgressPage/ProgressPage';
import { SavedAnalysesPage } from 'apps/sigma2-ui/src/pages/SavedAnalysesPage/SavedAnalysesPage';
import { DatabaseSchedulesPage } from 'apps/sigma2-ui/src/data-wizard/components/DatabaseSchedulesPage';
import { DatabaseSchedulesAllPage } from 'apps/sigma2-ui/src/data-wizard/components/DatabaseSchedulesAllPage';
import { DatabaseRubricBankPage } from 'apps/sigma2-ui/src/data-wizard/components/DatabaseRubricBankPage';
import { DatabaseRubricBankConstructPage } from 'apps/sigma2-ui/src/data-wizard/components/DatabaseRubricBankConstructPage';
import { DatabaseRubricBankItemsPage } from 'apps/sigma2-ui/src/data-wizard/components/DatabaseRubricBankItemsPage';
import { DatabaseRubricBankItemPage } from 'apps/sigma2-ui/src/data-wizard/components/DatabaseRubricBankItemPage';
import { DashboardsListPage } from 'apps/sigma2-ui/src/pages/Dashboards/DashboardsListPage';
import { GroupsPage } from 'apps/sigma2-ui/src/pages/GroupsPage';
import { GroupNewPage } from 'apps/sigma2-ui/src/pages/GroupNewPage';
import { GroupEntitlementsPage } from 'apps/sigma2-ui/src/pages/GroupEntitlementsPage';
import { GroupUsersPage } from 'apps/sigma2-ui/src/pages/GroupUsersPage';
import { NlpGraphPage } from 'apps/sigma2-ui/src/nlp/NlpGraphPage';
import { AuditsPage } from 'apps/sigma2-ui/src/pages/AuditsPage';
import { MergeRealtimeWritebackConfigsPage } from 'apps/sigma2-ui/src/pages/MergeRealtimeWritebackConfig/MergeRealtimeWritebackConfigsPage';
import { MergeRealtimeWritebackConfigDetailsPage } from 'apps/sigma2-ui/src/pages/MergeRealtimeWritebackConfig/MergeRealtimeWritebackConfigDetailsPage';
import { KeyFactorsPage } from 'apps/sigma2-ui/src/pages/KeyFactorsPage';
import { EmbedDashboardPage } from 'apps/sigma2-ui/src/pages/Dashboards/EmbedDashboardPage';
import { ConnectionsPage } from 'apps/sigma2-ui/src/pages/ConnectionsPage';
import { OrganizationConnectionsConfigurationPage } from 'apps/sigma2-ui/src/pages/OrganizationConnectionsConfigurationPage';
import { DataGeneratorPage } from 'apps/sigma2-ui/src/pages/DataGenerator';
import { DataGeneratorRunsPage } from 'apps/sigma2-ui/src/pages/DataGenerator';
import { CreateRubricPageWrapper } from 'apps/sigma2-ui/src/pages/Rubrics/CreateRubricPage';
import { ListRubricsPage } from 'apps/sigma2-ui/src/pages/Rubrics/ListRubricsPage';
import { DataCatalogPage } from 'apps/sigma2-ui/src/pages/DataCatalogPage';
import { DatabaseFeatureFlagsPage } from 'apps/sigma2-ui/src/pages/DatabaseFeatureFlagsPage';
import { DashboardAccessPage } from 'apps/sigma2-ui/src/pages/Dashboards/DashboardAccessPage';
import { SharedAccessDashboardPage } from 'apps/sigma2-ui/src/pages/Dashboards/SharedAccessDashboardPage';

export const HomeRoute: PageRoute = {
  page: 'Home',
  route: {
    path: '/',
    element: <HomeRedirect />,
  },
  focusArea: null,
};

export const LoginRoute: PageRoute = {
  page: 'Login',
  route: {
    path: '/login',
    element: <LoginPage />,
  },
  focusArea: null,
};

export const OverviewRoute: PageRoute = {
  page: 'Overview',
  route: {
    path: '/overview/:analysisName?',
    element: <OverviewPage />,
  },
  focusArea: null,
};

// Give each focus area a key to prevent React from reusing the same component for the page.
export const HiringRoute: PageRoute = {
  page: 'Hiring',
  route: {
    path: '/hiring/:sectionName?',
    element: <FocusAreaPage key={'Hiring'} focusArea={'Hiring'} />,
  },
  focusArea: 'Hiring',
};

export const CompensationRoute: PageRoute = {
  page: 'Compensation',
  route: {
    path: '/compensation/:sectionName?',
    element: <FocusAreaPage key={'Compensation'} focusArea={'Compensation'} />,
  },
  focusArea: 'Compensation',
};

export const PerformanceRoute: PageRoute = {
  page: 'Performance',
  route: {
    path: '/performance/:sectionName?',
    element: <FocusAreaPage key={'Performance'} focusArea={'Performance'} />,
  },
  focusArea: 'Performance',
};

export const PromotionRoute: PageRoute = {
  page: 'Promotion',
  route: {
    path: '/promotion/:sectionName?',
    element: <FocusAreaPage key={'Promotion'} focusArea={'Promotion'} />,
  },
  focusArea: 'Promotion',
};

export const AttritionRoute: PageRoute = {
  page: 'Attrition',
  route: {
    path: '/attrition/:sectionName?',
    element: <FocusAreaPage key={'Attrition'} focusArea={'Attrition'} />,
  },
  focusArea: 'Attrition',
};

export const EngagementRoute: PageRoute = {
  page: 'Engagement',
  route: {
    path: '/engagement/:sectionName?',
    element: <FocusAreaPage key={'Engagement'} focusArea={'Engagement'} />,
  },
  focusArea: 'Engagement',
};

export const LeadershipRoute: PageRoute = {
  page: 'Leadership',
  route: {
    path: '/leadership/:sectionName?',
    element: <FocusAreaPage key={'Leadership'} focusArea={'Leadership'} />,
  },
  focusArea: 'Leadership',
};

export const CopilotRoute: PageRoute = {
  page: 'CopilotPage',
  route: {
    path: '/copilot/:copilotType?/:displayType?',
    element: <CopilotPage />,
  },
  focusArea: null,
};

export const KeyFactorsRoute: PageRoute = {
  page: 'KeyFactorsPage',
  route: {
    path: '/success-factors',
    element: <KeyFactorsPage />,
  },
  focusArea: null,
};

export const ProgressRoute: PageRoute = {
  page: 'ProgressPage',
  route: {
    path: '/progress/:sectionName?',
    element: <ProgressPage />,
  },
  focusArea: null,
};

export const SavedAnalysesRoute: PageRoute = {
  page: 'SavedAnalysesPage',
  route: {
    path: '/saved-analyses',
    element: <SavedAnalysesPage />,
  },
  focusArea: null,
};

export const DashboardsRoute: PageRoute = {
  page: 'DashboardsPage',
  route: {
    path: '/dashboards',
    element: <DashboardsListPage />,
  },
  focusArea: null,
};

export const DashboardDetailsRoute: PageRoute = {
  page: 'DashboardDetailsRoute',
  route: {
    path: '/dashboards/:dashboardId',
    element: <DashboardAccessPage />,
  },
  focusArea: null,
};

export const ExploreRoute: PageRoute = {
  page: 'ExplorePage',
  route: {
    path: '/explore/:sectionName?',
    element: <ExplorePage />,
  },
  focusArea: null,
};

export const AdminRoute: PageRoute = {
  page: 'Admin',
  route: {
    path: '/admin',
    element: <AdminPage />,
  },
  focusArea: null,
};

export const GroupsRoute: PageRoute = {
  page: 'Groups',
  route: {
    path: '/groups',
    element: <GroupsPage />,
  },
  focusArea: null,
};

export const GroupNewRoute: PageRoute = {
  page: 'GroupNew',
  route: {
    path: '/groups/new',
    element: <GroupNewPage />,
  },
  focusArea: null,
};

export const GroupEntitlementsRoute: PageRoute = {
  page: 'GroupEntitlements',
  route: {
    path: '/groups/:groupId/entitlements',
    element: <GroupEntitlementsPage />,
  },
  focusArea: null,
};

export const GroupUsersRoute: PageRoute = {
  page: 'GroupUsers',
  route: {
    path: '/groups/:groupId/users',
    element: <GroupUsersPage />,
  },
  focusArea: null,
};

// export const GroupEditRoute: PageRoute = {
//   page: 'GroupEdit',
//   route: {
//     path: '/groups/edit/:groupId',
//     element: <GroupEditPage />,
//   },
//   focusArea: null,
// };

export const UsersRoute: PageRoute = {
  page: 'Users',
  route: {
    path: '/users',
    element: <UsersPage />,
  },
  focusArea: null,
};

export const UserRoute: PageRoute = {
  page: 'User',
  route: {
    path: '/users/:userId',
    element: <UserPage />,
  },
  focusArea: null,
};

export const OrganizationsRoute: PageRoute = {
  page: 'Organizations',
  route: {
    path: '/organizations',
    element: <OrganizationsPage />,
  },
  focusArea: null,
};

export const OrganizationEditRoute: PageRoute = {
  page: 'OrganizationEdit',
  route: {
    path: '/organizations/edit/:organizationId',
    element: <OrganizationEditPage />,
  },
  focusArea: null,
};

export const OrganizationNewRoute: PageRoute = {
  page: 'OrganizationNew',
  route: {
    path: '/organizations/new',
    element: <OrganizationNewPage />,
  },
  focusArea: null,
};

export const OrganizationEntitlementsRoute: PageRoute = {
  page: 'OrganizationEntitlements',
  route: {
    path: '/organizations/:organizationId/entitlements',
    element: <OrganizationEntitlementsPage />,
  },
  focusArea: null,
};

export const EmailsRoute: PageRoute = {
  page: 'Emails',
  route: {
    path: '/emails',
    element: <EmailsPage />,
  },
  focusArea: null,
};

export const ResetPasswordRoute: PageRoute = {
  page: 'ResetPassword',
  route: {
    path: '/reset-password/:resetToken',
    element: <ResetPasswordPage />,
  },
  focusArea: null,
};

export const ForgotPasswordRoute: PageRoute = {
  page: 'ForgotPassword',
  route: {
    path: '/forgot-password',
    element: <ForgotPasswordPage />,
  },
  focusArea: null,
};

export const TreatmentCenterRoute: PageRoute = {
  page: 'TreatmentCenter',
  route: {
    path: '/treatment-center',
    element: <TreatmentCenterPage />,
  },
  focusArea: null,
};

export const GlossaryRoute: PageRoute = {
  page: 'Glossary',
  route: {
    path: '/glossary',
    element: <GlossaryPage />,
  },
  focusArea: null,
};

export const WelcomeRoute: PageRoute = {
  page: 'Welcome',
  route: {
    path: '/welcome',
    element: <WelcomePage />,
  },
  focusArea: null,
};

export const AdminFeatureFlagsRoute: PageRoute = {
  page: 'AdminFeatureFlags',
  route: {
    path: '/feature-flags',
    element: <AdminFeatureFlagsPage />,
  },
  focusArea: null,
};

export const Http404Route: PageRoute = {
  page: 'Http404',
  route: {
    path: '*',
    element: <Http404Page />,
  },
  focusArea: null,
};

export const AdminSSORoute: PageRoute = {
  page: 'AdminSSOPage',
  route: {
    path: '/sso-main',
    element: <AdminSSOPage />,
  },
  focusArea: null,
};

export const AdminSSOIdentityProviderRoute: PageRoute = {
  page: 'AdminSSOIdentityProvider',
  route: {
    path: '/sso-main/identity-provider/:identityProviderId',
    element: <AdminSSOIdentityProviderPage />,
  },
  focusArea: null,
};

export const AdminSSORoleMappingsRoute: PageRoute = {
  page: 'AdminSSORoleMappings',
  route: {
    path: '/sso-main/identity-provider/:identityProviderId/role-mappings',
    element: <AdminSSORoleMappingsPage />,
  },
  focusArea: null,
};

export const AdminSSORoleMappingRoute: PageRoute = {
  page: 'AdminSSORoleMapping',
  route: {
    path: '/sso-main/identity-provider/:identityProviderId/role-mapping/:mappingType',
    element: <AdminSSORoleMappingPage />,
  },
  focusArea: null,
};

export const DatabasesRoute: PageRoute = {
  page: 'Databases',
  route: {
    path: '/databases',
    element: <DatabasesPage />,
  },
  focusArea: null,
};

export const DatabasesNewRoute: PageRoute = {
  page: 'DatabasesNew',
  route: {
    path: '/organizations/:organizationId/databases/new',
    element: <DatabasesNewPage />,
  },
  focusArea: null,
};

export const DatabasesEditRoute: PageRoute = {
  page: 'DatabasesEdit',
  route: {
    path: '/organizations/:organizationId/databases/edit/:databaseId',
    element: <DatabasesEditPage />,
  },
  focusArea: null,
};

export const DatabaseScheduleRoute: PageRoute = {
  page: 'DatabaseSchedule',
  route: {
    path: '/organizations/:organizationId/databases/:databaseId/schedule/:scheduleId',
    element: <DatabaseSchedulePage />,
  },
  focusArea: null,
};

export const DatabaseSchedulesRoute: PageRoute = {
  page: 'DatabaseSchedules',
  route: {
    path: '/organizations/:organizationId/databases/:databaseId/schedules',
    element: <DatabaseSchedulesPage />,
  },
  focusArea: null,
};

export const DatabaseSchedulesAllRoute: PageRoute = {
  page: 'DatabaseSchedulesAllPage',
  route: {
    path: '/schedules',
    element: <DatabaseSchedulesAllPage />,
  },
  focusArea: null,
};

export const DatabaseRevisionsRoute: PageRoute = {
  page: 'DatabaseRevisions',
  route: {
    path: '/organizations/:organizationId/databases/:databaseId/revisions',
    element: <DatabaseRevisionsPage />,
  },
  focusArea: null,
};

export const DatabasesDataSetsRoute: PageRoute = {
  page: 'DatabasesDataSets',
  route: {
    path: '/organizations/:organizationId/databases/:databaseId/data-sets',
    element: <DatabasesDataSetsPage />,
  },
  focusArea: null,
};

export const DataSetNewRoute: PageRoute = {
  page: 'DataSetNew',
  route: {
    path: '/organizations/:organizationId/databases/:databaseId/data-sets/new',
    element: <DataSetNewPage />,
  },
  focusArea: null,
};

export const DataSetEditRoute: PageRoute = {
  page: 'DataSetEdit',
  route: {
    path: '/organizations/:organizationId/databases/:databaseId/data-sets/edit/:dataSetId',
    element: <DataSetEditPage />,
  },
  focusArea: null,
};

export const DataSetPullUploadRoute: PageRoute = {
  page: 'DataSetPullUpload',
  route: {
    path: '/organizations/:organizationId/databases/:databaseId/data-sets/:dataSetId/pull-upload',
    element: <DataSetPullUploadPage />,
  },
  focusArea: null,
};

export const DatabasesByOrganizationRoute: PageRoute = {
  page: 'DatabasesByOrganization',
  route: {
    path: '/organizations/:organizationId/databases',
    element: <DatabasesByOrganizationPage />,
  },
  focusArea: null,
};

export const DatabaseRevisionsSchemaRoute: PageRoute = {
  page: 'DatabaseSchema',
  route: {
    path: '/organizations/:organizationId/databases/:databaseId/revisions/:revisionId/schema',
    element: <DatabaseSchemaPage />,
  },
  focusArea: null,
};

export const TransformRoute: PageRoute = {
  page: 'Transform',
  route: {
    path: '/organizations/:organizationId/databases/:databaseId/transform',
    element: <TransformPage />,
  },
  focusArea: null,
};

export const DataSetPostProcessingScriptRoute: PageRoute = {
  page: 'DataSetPostProcessingScript',
  route: {
    path: '/organizations/:organizationId/databases/:databaseId/data-sets/:dataSetId/post-processing-script',
    element: <DataSetPostProcessingScriptPage />,
  },
  focusArea: null,
};

export const CallbackLoginRoute: PageRoute = {
  page: 'CallbackLogin',
  route: {
    path: '/callback-login',
    element: <CallbackLoginPage />,
  },
  focusArea: null,
};

export const CallbackLogoutRoute: PageRoute = {
  page: 'CallbackLogout',
  route: {
    path: '/callback-logout',
    element: <CallbackLogoutPage />,
  },
  focusArea: null,
};

export const DatabaseRubricBankRoute: PageRoute = {
  page: 'DatabaseRubricBank',
  route: {
    path: '/organizations/:organizationId/databases/:databaseId/rubric-bank',
    element: <DatabaseRubricBankPage />,
  },
  focusArea: null,
};

export const DatabaseRubricBankConstructRoute: PageRoute = {
  page: 'DatabaseRubricBankConstruct',
  route: {
    path: '/organizations/:organizationId/databases/:databaseId/rubric-bank-constructs/:constructId',
    element: <DatabaseRubricBankConstructPage />,
  },
  focusArea: null,
};

export const DatabaseRubricBankItemsRoute: PageRoute = {
  page: 'DatabaseRubricBankItems',
  route: {
    path: '/organizations/:organizationId/databases/:databaseId/rubric-bank-items',
    element: <DatabaseRubricBankItemsPage />,
  },
  focusArea: null,
};

export const DatabaseRubricBankItemRoute: PageRoute = {
  page: 'DatabaseRubricBankItem',
  route: {
    path: '/organizations/:organizationId/databases/:databaseId/rubric-bank-items/:itemId',
    element: <DatabaseRubricBankItemPage />,
  },
  focusArea: null,
};

export const NlpGraphRoute: PageRoute = {
  page: 'NlpGraphPage',
  route: {
    path: '/nlp-graph',
    element: <NlpGraphPage />,
  },
  focusArea: null,
};

export const AuditsRoute: PageRoute = {
  page: 'Audits',
  route: {
    path: '/audits',
    element: <AuditsPage />,
  },
  focusArea: null,
};

export const MergeRealtimeWritebackConfigsRoute: PageRoute = {
  page: 'MergeRealtimeConfigsPage',
  route: {
    path: '/organizations/:organizationId/databases/:databaseId/merge-realtime-writeback-configs',
    element: <MergeRealtimeWritebackConfigsPage />,
  },
  focusArea: null,
};

export const DatabaseFeatureFlagsRoute: PageRoute = {
  page: 'DatabaseFeatureFlagsPage',
  route: {
    path: '/organizations/:organizationId/databases/:databaseId/feature-flags',
    element: <DatabaseFeatureFlagsPage />,
  },
  focusArea: null,
};

export const MergeRealtimeWritebackConfigDetailsRoute: PageRoute = {
  page: 'MergeRealtimeConfigDetailsPage',
  route: {
    path: '/organizations/:organizationId/databases/:databaseId/merge-realtime-writeback-configs/:writebackConfigId',
    element: <MergeRealtimeWritebackConfigDetailsPage />,
  },
  focusArea: null,
};

export const OrganizationPrivateNetworkingEntitlementsRoute: PageRoute = {
  page: 'OrganizationPrivateNetworkingEntitlements',
  route: {
    path: '/organization-private-networking-entitlements',
    element: <OrganizationPrivateNetworkingEntitlementsPage />,
  },
  focusArea: null,
};

export const ExternalStreamlitAppsRoute: PageRoute = {
  page: 'ExternalStreamlitApps',
  route: {
    path: '/external-streamlit-apps',
    element: <ExternalStreamlitAppsPage />,
  },
  focusArea: null,
};

export const ExternalDagsterTransformsRoute: PageRoute = {
  page: 'ExternalDagsterTransforms',
  route: {
    path: '/external-dagster-transforms',
    element: <ExternalDagsterTransformsPage />,
  },
  focusArea: null,
};

export const DataGeneratorRoute: PageRoute = {
  page: 'DataGenerator',
  route: {
    path: '/data-generator/create',
    element: <DataGeneratorPage />,
  },
  focusArea: null,
};

export const DataGeneratorByRunIdRoute: PageRoute = {
  page: 'DataGenerator',
  route: {
    path: '/data-generator/runs/:runId',
    element: <DataGeneratorPage />,
  },
  focusArea: null,
};

export const DataGeneratorRunsRoute: PageRoute = {
  page: 'DataGenerator',
  route: {
    path: '/data-generator',
    element: <DataGeneratorRunsPage />,
  },
  focusArea: null,
};

export const EmbedDashboardRoute: PageRoute = {
  page: 'EmbedDashboard',
  route: {
    path: '/embed/dashboards/:dashboardId',
    element: <EmbedDashboardPage />,
  },
  focusArea: null,
  appWrapperOverride: 'embed',
};

export const SharedAccessDashboardRoute: PageRoute = {
  page: 'SharedAccessDashboardPage',
  route: {
    path: '/shared/dashboards/:dashboardId',
    element: <SharedAccessDashboardPage />,
  },
  focusArea: null,
  appWrapperOverride: 'embed',
};

export const ConnectionsRoute: PageRoute = {
  page: 'Connections',
  route: {
    path: '/connections',
    element: <ConnectionsPage />,
  },
  focusArea: null,
};

export const OrganizationConnectionsConfigurationRoute: PageRoute = {
  page: 'OrganizationConnectionsConfiguration',
  route: {
    path: '/organizations/:organizationId/connections',
    element: <OrganizationConnectionsConfigurationPage />,
  },
  focusArea: null,
};

export const CreateRubricRoute: PageRoute = {
  page: 'CreateRubricPage',
  route: {
    path: '/rubrics/create/:gradingType',
    element: <CreateRubricPageWrapper mode={'create'} />,
  },
  focusArea: null,
};

export const EditRubricRoute: PageRoute = {
  page: 'CreateRubricPage',
  route: {
    path: '/rubrics/edit/:rubricId',
    element: <CreateRubricPageWrapper mode={'edit'} />,
  },
  focusArea: null,
};

export const DuplicateRubricRoute: PageRoute = {
  page: 'CreateRubricPage',
  route: {
    path: '/rubrics/duplicate/:rubricId',
    element: <CreateRubricPageWrapper mode={'duplicate'} />,
  },
  focusArea: null,
};

export const ListRubricsRoute: PageRoute = {
  page: 'ListRubricsPage',
  route: {
    path: '/rubrics',
    element: <ListRubricsPage />,
  },
  focusArea: null,
};

export const DataCatalogRoute: PageRoute = {
  page: 'DataCatalogPage',
  route: {
    path: '/data-catalog',
    element: <DataCatalogPage />,
  },
  focusArea: null,
};

export const ROUTES: PageRoute[] = [
  HomeRoute,
  LoginRoute,
  OverviewRoute,
  HiringRoute,
  CopilotRoute,
  KeyFactorsRoute,
  CompensationRoute,
  PerformanceRoute,
  PromotionRoute,
  AttritionRoute,
  EngagementRoute,
  LeadershipRoute,
  AdminRoute,
  UsersRoute,
  UserRoute,
  OrganizationsRoute,
  OrganizationEditRoute,
  OrganizationNewRoute,
  OrganizationEntitlementsRoute,
  EmailsRoute,
  ResetPasswordRoute,
  ForgotPasswordRoute,
  TreatmentCenterRoute,
  GlossaryRoute,
  WelcomeRoute,
  AdminFeatureFlagsRoute,
  AdminSSORoute,
  AdminSSOIdentityProviderRoute,
  AdminSSORoleMappingsRoute,
  AdminSSORoleMappingRoute,
  DatabasesRoute,
  DatabaseScheduleRoute,
  DatabaseSchedulesRoute,
  DatabaseSchedulesAllRoute,
  DatabasesNewRoute,
  DatabasesEditRoute,
  DatabasesDataSetsRoute,
  DatabasesByOrganizationRoute,
  DatabaseRevisionsSchemaRoute,
  DatabaseRevisionsRoute,
  DataSetNewRoute,
  DataSetEditRoute,
  DataSetPullUploadRoute,
  TransformRoute,
  // TransformVisualViewRoute,
  DataSetPostProcessingScriptRoute,
  CallbackLoginRoute,
  CallbackLogoutRoute,
  Http404Route,
  ProgressRoute,
  SavedAnalysesRoute,
  ExploreRoute,
  DatabaseRubricBankRoute,
  DatabaseRubricBankConstructRoute,
  DatabaseRubricBankItemsRoute,
  DatabaseRubricBankItemRoute,
  DashboardsRoute,
  DashboardDetailsRoute,
  GroupsRoute,
  GroupNewRoute,
  GroupEntitlementsRoute,
  GroupUsersRoute,
  NlpGraphRoute,
  AuditsRoute,
  MergeRealtimeWritebackConfigDetailsRoute,
  MergeRealtimeWritebackConfigsRoute,
  DatabaseFeatureFlagsRoute,
  OrganizationPrivateNetworkingEntitlementsRoute,
  ExternalStreamlitAppsRoute,
  ExternalDagsterTransformsRoute,
  EmbedDashboardRoute,
  SharedAccessDashboardRoute,
  ConnectionsRoute,
  OrganizationConnectionsConfigurationRoute,
  DataGeneratorRoute,
  DataGeneratorByRunIdRoute,
  DataGeneratorRunsRoute,
  CreateRubricRoute,
  EditRubricRoute,
  DuplicateRubricRoute,
  ListRubricsRoute,
  DataCatalogRoute,
];

export const FocusAreaRoutes = [
  HiringRoute,
  CompensationRoute,
  PerformanceRoute,
  PromotionRoute,
  AttritionRoute,
  EngagementRoute,
  LeadershipRoute,
];

// FIXME: Make this return a `Result<PageRoute, GetFocusAreaRouteError>` instead of throwing.
export const getFocusAreaRoute = (focusArea: FocusArea) => {
  const route = FocusAreaRoutes.find((route) => route.focusArea === focusArea);

  if (!route) {
    throw new Error(`No route found for focus area ${focusArea}`);
  }

  return route;
};
